firebird.factory('videoroomService', [
    '$rootScope',
    'logService',
    function ($rootScope, logService) {
        const logger = logService.createLoggerWithSource('videoroomService');

        var layouts = {
            SPOTLIGHT: 'spotlight',
            GALLERY: 'gallery',
            GRID: 'grid',
            ALLHANDS: 'allhands'
        };

        var feedType = {
            SHOW_ALL_WEBCAM_VIDEOS: 'showAllWebcamVideos',
            SHOW_SHARED_CONTENT: 'showSharedContent'
        };

        var videoList = [];

        var service = {
            layouts: layouts,
            feedType: feedType,
            setCurrentLayout: setCurrentLayout,
            getCurrentLayout: getCurrentLayout,
            getPreviousLayout: getPreviousLayout,
            setVideoList: setVideoList,
            getVideoList: getVideoList,
            isLayoutInLargeGalleryView: isLayoutInLargeGalleryView,
            setNumberOfFeedsToEnableLGV: setNumberOfFeedsToEnableLGV,
            setNumberOfFeedsToDisableLGV: setNumberOfFeedsToDisableLGV,
            getNumberOfFeedsToEnableLGV: getNumberOfFeedsToEnableLGV,
            getNumberOfFeedsToDisableLGV: getNumberOfFeedsToDisableLGV,
            setIsVideoLowFromServer: setIsVideoLowFromServer,
            getIsVideoLowFromServer: getIsVideoLowFromServer
        };

        var currentLayout = service.layouts.GALLERY;
        var previousLayout = service.layouts.GALLERY;

        var _numberOfFeedsToEnableLGV = 31;
        var _numberOfFeedsToDisableLGV = 25;

        var _lpmFromServer = false;

        $rootScope.$on('videoroom-list-updated', onVideoroomListUpdated);

        return service;

        function setNumberOfFeedsToEnableLGV(value) {
            value = parseInt(value);

            if (value > 2 && value <= 31) {
                _numberOfFeedsToEnableLGV = parseInt(value);
            }
        }

        function setNumberOfFeedsToDisableLGV(value) {
            value = parseInt(value);

            if (value >= 0 && value < _numberOfFeedsToEnableLGV) {
                _numberOfFeedsToDisableLGV = parseInt(value);
            }
        }

        function getNumberOfFeedsToEnableLGV() {
            return _numberOfFeedsToEnableLGV;
        }

        function getNumberOfFeedsToDisableLGV() {
            return _numberOfFeedsToDisableLGV;
        }

        function setCurrentLayout(newLayout) {
            if (newLayout !== currentLayout) {
                previousLayout = currentLayout;
                currentLayout = newLayout;

                $rootScope.$broadcast('layout-changed', { newLayout: currentLayout, previousLayout: previousLayout });
            }
        }

        function getCurrentLayout() {
            return currentLayout;
        }

        function getPreviousLayout() {
            return previousLayout;
        }

        function isLayoutInLargeGalleryView() {
            return currentLayout === service.layouts.ALLHANDS;
        }

        function onVideoroomListUpdated(e, data) {
            logger.log('videoroomService - updated videoroom list received from server');

            if (data && data.publisherData && typeof data.publisherAdded === 'boolean') {
                var index = videoList.findIndex(function (publisher) {
                    return (
                        publisher.attendantId === data.publisherData.attendantId &&
                        publisher.type === data.publisherData.type
                    );
                });

                if (data.publisherAdded) {
                    if (index === -1) {
                        logger.log(
                            'videoroomService - adding publisher to videoList:',
                            data.publisherData.publisherId,
                            data.publisherData.type
                        );
                    } else {
                        logger.log(
                            'videoroomService - updating publisher in videoList:',
                            data.publisherData.publisherId,
                            data.publisherData.type
                        );
                        videoList.splice(index, 1);
                    }

                    videoList.push(data.publisherData);
                } else {
                    if (index !== -1) {
                        logger.log(
                            'videoroomService - removing publisher from videoroom list:',
                            data.publisherData.publisherId,
                            data.publisherData.type
                        );
                        videoList.splice(index, 1);
                    } else {
                        logger.log(
                            'videoroomService - unable to remove publisher, not found in videoroom list:',
                            data.publisherData.publisherId,
                            data.publisherData.type
                        );
                    }
                }
            } else {
                logger.warn('onVideoroomListUpdated', 'invalid videoList data', data);
            }
        }

        function setVideoList(newList) {
            videoList = newList;
        }

        function getVideoList() {
            return videoList;
        }

        function setIsVideoLowFromServer(newVal) {
            _lpmFromServer = newVal;
        }

        function getIsVideoLowFromServer() {
            return _lpmFromServer;
        }
    }
]);
